<template>
  <div>
    This application has reached end-of-life.
	<br>
	Tasneem & Lucky: Please destroy the application in Digital Ocean.
  </div>
</template>




